import { Lock } from "components/icons/generated";
import Button from "ds/components/Button";
import { Stack } from "types/generated";
import Tooltip from "ds/components/Tooltip";

import { showStackLockNoteModal } from "../LockNoteModal";

type LockButtonProps = {
  stackId: Stack["id"];
  disabledTooltip?: string;
};

const LockButton = ({ stackId, disabledTooltip }: LockButtonProps) => {
  const onClick = () => {
    showStackLockNoteModal({
      stackId,
    });
  };

  return (
    <Tooltip
      active={!!disabledTooltip}
      on={(tooltipProps) => (
        <Button
          {...tooltipProps}
          onPress={onClick}
          disabled={!!disabledTooltip}
          startIcon={Lock}
          variant="secondary"
        >
          Lock
        </Button>
      )}
      placement="top"
    >
      {disabledTooltip}
    </Tooltip>
  );
};

export default LockButton;
